export default __webpack_public_path__ + "static/media/contact-people.28f518bd.svg";